import React from "react";

var HeartIcon = function HeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.199 2.04c-2.606-.284-4.262.961-6.199 3.008C9.955 3.001 8.407 1.756 5.801 2.04 2.257 2.428-.52 6.47.083 10 1.049 15.659 6.027 19 12 22c5.973-3 10.951-6.341 11.917-12 .603-3.53-2.174-7.572-5.718-7.96z"
  }));
};

HeartIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
HeartIcon.defaultProps.solid = true;
export default HeartIcon;